module.exports = __webpack_public_path__ + "img/zuzhi.f2211d89.png";